export default __webpack_public_path__ + "static/media/python.2424f1ad.png";